module.exports = __webpack_public_path__ + "static/img/me_studey_bg@2x.6da47b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/me_studey_bg@2x.png
// module id = tgzm
// module chunks = 1